import React, { useState, useCallback, useEffect } from "react"
import { Bar, defaults } from "react-chartjs-2"
import chartData from "../data/capacity-development"
import Modal from "react-modal"
import IconClose from "../images/close.inline.svg"
Modal.setAppElement("#___gatsby")
defaults.defaultFontFamily = "Prompt"
defaults.defaultFontSize = 13
defaults.maintainAspectRatio = false

const pluginPadding = {
  id: "paddingBelowLegends",
  beforeInit: function (chart, options) {
    chart.legend.afterFit = function () {
      this.height = this.height + 10
    }
  },
}

export default function BarChart({
  id,
  title,
  subTitle,
  measure,
  figureNumber,
  caption,
  source,
  children,
}) {
  const [viewAsTable, setViewAsTable] = useState(false)

  const downHandler = useCallback(
    ({ key }) => {
      if ((key === "Escape" || key === "Esc") && viewAsTable) {
        setViewAsTable(false)
      }
    },
    [viewAsTable]
  )

  useEffect(() => {
    document.addEventListener("keydown", downHandler)
    // Remove event listeners on cleanup
    return () => {
      document.removeEventListener("keydown", downHandler)
    }
  }, [viewAsTable, downHandler])

  const data = chartData.find(obj => {
    return obj.id === id
  }).data

  const options = chartData.find(obj => {
    return obj.id === id
  }).options

  // Create text fallback for chart
  var barChartLabel = ""

  data.labels.forEach((label, index) => {
    data.datasets.forEach((dataset, i) => {
      barChartLabel += `${dataset.data[index].toLocaleString()} ${measure}${
        dataset.label ? " " + dataset.label : ""
      }${i < data.datasets.length - 1 ? " and " : ""}`
    })

    barChartLabel += ` in ${label}${
      index < data.labels.length - 1 ? "; " : "."
    }`
  })

  const formatSource = text => {
    let formattedText = text.split("/n").map((item, key) => {
      return (
        <span key={key}>
          {item}
          <br />
        </span>
      )
    })

    return formattedText
  }

  return (
    <div className="chart chart--bar">
      {figureNumber && (
        <div className="chart__figure-number">Figure {figureNumber}</div>
      )}
      {title && <h3 className="chart__title">{title}</h3>}
      {subTitle &&
        (title ? (
          <h4 className="chart__sub-title">{subTitle}</h4>
        ) : (
          <h3 className="chart__sub-title">{subTitle}</h3>
        ))}
      <figure role="group">
        <figure
          className={
            options.height
              ? "chart__container chart__container--" + options.height
              : "chart__container"
          }
          aria-label={barChartLabel}
        >
          <Bar
            data={data}
            options={options}
            fallbackContent={<div>Any Content Can Go Here</div>}
            plugins={[pluginPadding]}
          />
        </figure>
        {caption && (
          <figcaption>
            <p className="chart__caption">{caption}</p>
            {source && (
              <p
                className="chart__source"
                dangerouslySetInnerHTML={{ __html: source }}
              />
            )}
          </figcaption>
        )}
      </figure>
      {children ? (
        <>
          <Modal
            isOpen={viewAsTable}
            overlayClassName="overlay"
            className="overlay__content"
            bodyOpenClassName="util__body-lock"
          >
            <button
              className="overlay__button overlay__button--close"
              onClick={() => setViewAsTable(false)}
              aria-label="Close overlay"
            >
              <IconClose />
            </button>
            {children}
          </Modal>
          <button
            className="chart__toggle"
            onClick={() => setViewAsTable(!viewAsTable)}
          >
            View Data as a Table
          </button>
        </>
      ) : null}
    </div>
  )
}
